/* loaded by smart-asset */
export default require("./assets/cases-per-full-tier.i.svg")